import { LaunchpadId, launchpadDefinitions } from '@/constants/launchpads';

// Current 0x sources and historical providers found in trade history.
// Use lowercase family keys where possible: "uniswap" covers Uniswap_V3 and UniswapV3.
export const liquidityProviderLogos = {
  '0x': '/images/liquidity-providers/0x.webp',
  'aave': '/images/liquidity-providers/aave.webp',
  'aborean': '/images/liquidity-providers/aborean.webp',
  'acryptos': '/images/liquidity-providers/acryptos.webp',
  'aerodrome': '/images/liquidity-providers/aerodrome.webp',
  'agni': '/images/liquidity-providers/agni.webp',
  'alandale': '/images/liquidity-providers/alandale.webp',
  'alienbase': '/images/liquidity-providers/alienbase.webp',
  'ambient': '/images/liquidity-providers/ambient.webp',
  'apeswap': '/images/liquidity-providers/apeswap.webp',
  // SyncSwap's Aqua pools have a separate 0x source name.
  'aqua': '/images/liquidity-providers/syncswap.webp',
  'atlantis': '/images/liquidity-providers/atlantis.webp',
  'babydogeswap': '/images/liquidity-providers/babydogeswap.webp',
  'bags': launchpadDefinitions[LaunchpadId.BAGS].logo,
  'bakeryswap': '/images/liquidity-providers/bakeryswap.webp',
  'balancer': '/images/liquidity-providers/balancer.webp',
  'bancor': '/images/liquidity-providers/bancor.webp',
  'baseline': '/images/liquidity-providers/baseline.webp',
  'baseswap': '/images/liquidity-providers/baseswap.webp',
  'basex': '/images/liquidity-providers/basex.webp',
  'beanexchange': '/images/liquidity-providers/beanexchange.webp',
  'bebop': '/images/liquidity-providers/bebop.webp',
  'beethovenx': '/images/liquidity-providers/beethovenx.webp',
  'biswap': '/images/liquidity-providers/biswap.webp',
  'blackhole': '/images/liquidity-providers/blackhole.webp',
  'bladeswap': '/images/liquidity-providers/bladeswap.webp',
  'blaster': '/images/liquidity-providers/blaster.webp',
  'brownfi': '/images/liquidity-providers/brownfi.webp',
  'butter_swap': '/images/liquidity-providers/butterswap.webp',
  'camelot': '/images/liquidity-providers/camelot.webp',
  'capricorn': '/images/liquidity-providers/capricorn.webp',
  'cleo': '/images/liquidity-providers/cleo.webp',
  'clober': '/images/liquidity-providers/clober.webp',
  'compound': '/images/liquidity-providers/compound.webp',
  'crust': '/images/liquidity-providers/crust.webp',
  'cryptocom': '/images/liquidity-providers/cryptocom.webp',
  'curve': '/images/liquidity-providers/curve.webp',
  'cyberblast': '/images/liquidity-providers/cyberblast.webp',
  'dackieswap': '/images/liquidity-providers/dackieswap.webp',
  'defi_swap': '/images/liquidity-providers/defiswap.webp',
  'dfyn': '/images/liquidity-providers/dfyn.webp',
  'dodo': '/images/liquidity-providers/dodo.webp',
  'dyorswap': '/images/liquidity-providers/dyorswap.webp',
  'dyson': '/images/liquidity-providers/dyson.webp',
  'echodex': '/images/liquidity-providers/echodex.webp',
  'ekubo': '/images/liquidity-providers/ekubo.webp',
  'elfomofi': '/images/liquidity-providers/elfomofi.webp',
  'ellipsis': '/images/liquidity-providers/ellipsis.webp',
  'equalizer': '/images/liquidity-providers/equalizer.webp',
  'etherex': '/images/liquidity-providers/etherex.webp',
  'faze': launchpadDefinitions[LaunchpadId.FAZE].logo,
  'fenix': '/images/liquidity-providers/fenixcl.webp',
  // Fermi is operated by IMC; use its operator mark.
  'fermi': '/images/liquidity-providers/fermi.webp',
  'firebirdoneswap': '/images/liquidity-providers/firebirdoneswap.webp',
  'flap': launchpadDefinitions[LaunchpadId.FLAP].logo,
  'fluid': '/images/liquidity-providers/fluid.webp',
  'fluidlite': '/images/liquidity-providers/fluid.webp',
  'fourmeme': launchpadDefinitions[LaunchpadId.FOUR_MEME].logo,
  'fraxswap': '/images/liquidity-providers/fraxswap.webp',
  'fusionx': '/images/liquidity-providers/fusionx.webp',
  'giga': '/images/liquidity-providers/giga.webp',
  'gmx': '/images/liquidity-providers/gmx.webp',
  'hanji': '/images/liquidity-providers/hanji.webp',
  'hybra': '/images/liquidity-providers/hybra.webp',
  'hydrex': '/images/liquidity-providers/hydrex.webp',
  'hyperswap': '/images/liquidity-providers/hyperswap.webp',
  'infusion': '/images/liquidity-providers/infusion.webp',
  'inkyswap': '/images/liquidity-providers/inkyswap.webp',
  'integral': '/images/liquidity-providers/integral.webp',
  'ironswap': '/images/liquidity-providers/ironswap.webp',
  'iziswap': '/images/liquidity-providers/iziswap.webp',
  'jetswap': '/images/liquidity-providers/jetswap.webp',
  'kim': '/images/liquidity-providers/kim.webp',
  'kinetix': '/images/liquidity-providers/kinetix.webp',
  'kipseli': '/images/liquidity-providers/kipseli.webp',
  'kittenswap': '/images/liquidity-providers/kittenswap.webp',
  'knightswap': '/images/liquidity-providers/knightswap.webp',
  'kona': '/images/liquidity-providers/kona.webp',
  'ktx.finance': '/images/liquidity-providers/ktx.webp',
  'kuru': '/images/liquidity-providers/kuru.webp',
  'kyberdmm': '/images/liquidity-providers/kyberswap.webp',
  'lido': '/images/liquidity-providers/lido.webp',
  'liquidcore': '/images/liquidity-providers/liquidcore.webp',
  'lista': '/images/liquidity-providers/lista.webp',
  'lithos': '/images/liquidity-providers/lithos.webp',
  'lunarbase': '/images/liquidity-providers/lunarbase.webp',
  'lynex': '/images/liquidity-providers/lynex.webp',
  'maker_psm': '/images/liquidity-providers/maker.webp',
  'maverick': '/images/liquidity-providers/maverick.webp',
  'mdex': '/images/liquidity-providers/mdex.webp',
  'merchantmoe': '/images/liquidity-providers/merchantmoe.webp',
  'meshswap': '/images/liquidity-providers/meshswap.webp',
  'metavault': '/images/liquidity-providers/metavault.webp',
  'methlab_swap': '/images/liquidity-providers/methlabswap.webp',
  'metric': '/images/liquidity-providers/metric.webp',
  'mimswap': '/images/liquidity-providers/mimswap.webp',
  'mobiusmoney': '/images/liquidity-providers/mobiusmoney.webp',
  'mondaytrade': '/images/liquidity-providers/mondaytrade.webp',
  'monoswap': '/images/liquidity-providers/monoswap.webp',
  'morpheusswap': '/images/liquidity-providers/morpheusswap.webp',
  'morphex': '/images/liquidity-providers/morphex.webp',
  'mstable': '/images/liquidity-providers/mstable.webp',
  'nabla': '/images/liquidity-providers/nabla.webp',
  'naddotfun': launchpadDefinitions[LaunchpadId.NAD_FUN].logo,
  'native': '/images/liquidity-providers/native.webp',
  'nerve': '/images/liquidity-providers/nerve.webp',
  'nest': '/images/liquidity-providers/nest.webp',
  'nile': '/images/liquidity-providers/nile.webp',
  'nuri_cl': '/images/liquidity-providers/nuri.webp',
  'octoswap': '/images/liquidity-providers/octoswap.webp',
  'orcawhirlpools': '/images/liquidity-providers/orca.webp',
  'origin': '/images/liquidity-providers/origin.webp',
  'orion': '/images/liquidity-providers/orion.webp',
  'orvex': '/images/liquidity-providers/orvex.webp',
  'overnight': '/images/liquidity-providers/overnight.webp',
  'pancakeswap': '/images/liquidity-providers/pancakeswap.webp',
  'pangolin': '/images/liquidity-providers/pangolin.webp',
  'peach': launchpadDefinitions[LaunchpadId.PEACH].logo,
  'pharaoh': '/images/liquidity-providers/pharaoh.webp',
  'platypus': '/images/liquidity-providers/platypus.webp',
  'pons': launchpadDefinitions[LaunchpadId.PONS].logo,
  'printr': launchpadDefinitions[LaunchpadId.PRINTR].logo,
  'project_x': '/images/liquidity-providers/prjx.webp',
  'pumpfun': launchpadDefinitions[LaunchpadId.PUMP_FUN].logo,
  'pumpswap': launchpadDefinitions[LaunchpadId.PUMP_FUN].logo,
  'purps': '/images/liquidity-providers/purps.webp',
  'quickswap': '/images/liquidity-providers/quickswap.webp',
  'ramses': '/images/liquidity-providers/ramses.webp',
  'raydiumamm': '/images/liquidity-providers/raydium.webp',
  'raydiumclmm': '/images/liquidity-providers/raydium.webp',
  'raydiumcpmm': '/images/liquidity-providers/raydium.webp',
  'reservoir': '/images/liquidity-providers/reservoir.webp',
  'retro': '/images/liquidity-providers/retro.webp',
  'ringswap': '/images/liquidity-providers/ringswap.webp',
  'rocketpool': '/images/liquidity-providers/rocketpool.webp',
  'rubicon': '/images/liquidity-providers/rubicon.webp',
  'saddle': '/images/liquidity-providers/saddle.webp',
  'secta': '/images/liquidity-providers/secta.webp',
  'sectorone': '/images/liquidity-providers/sectorone.webp',
  'shibaswap': '/images/liquidity-providers/shibaswap.webp',
  'sky_migration': '/images/liquidity-providers/skymigration.webp',
  'skydrome': '/images/liquidity-providers/skydrome.webp',
  'solfi': '/images/liquidity-providers/solfi.webp',
  'solidly': '/images/liquidity-providers/solidly.webp',
  'soswap': '/images/liquidity-providers/soswap.webp',
  'spark': '/images/liquidity-providers/spark.webp',
  'spartadex': '/images/liquidity-providers/spartadex.webp',
  'spiritswap': '/images/liquidity-providers/spiritswap.webp',
  'spookyswap': '/images/liquidity-providers/spookyswap.webp',
  'squadswap': '/images/liquidity-providers/squadswap.webp',
  'stabblestableswap': '/images/liquidity-providers/stabble.webp',
  'stabbleweightedswap': '/images/liquidity-providers/stabble.webp',
  'stepn': '/images/liquidity-providers/stepn.webp',
  'stratum_exchange': '/images/liquidity-providers/stratumexchange.webp',
  'supswap': '/images/liquidity-providers/supswap.webp',
  'sushiswap': launchpadDefinitions[LaunchpadId.SUSHISWAP].logo,
  'swapbased': '/images/liquidity-providers/swapbased.webp',
  'swapblast': '/images/liquidity-providers/swapblast.webp',
  'swapmode': '/images/liquidity-providers/swapmode.webp',
  'swapsicle': '/images/liquidity-providers/swapsicle.webp',
  'synapse': '/images/liquidity-providers/synapse.webp',
  'syncswap': '/images/liquidity-providers/syncswap.webp',
  'synthswap': '/images/liquidity-providers/synthswap.webp',
  'tesseraswap': '/images/liquidity-providers/tesseraswap.webp',
  'thena': '/images/liquidity-providers/thena.webp',
  'thruster': '/images/liquidity-providers/thruster.webp',
  'tokan': '/images/liquidity-providers/tokan.webp',
  'topaz': '/images/liquidity-providers/topaz.webp',
  'traderjoe': '/images/liquidity-providers/traderjoe.webp',
  'ubeswap': '/images/liquidity-providers/ubeswap.webp',
  'ultrasolid': '/images/liquidity-providers/ultrasolid.webp',
  'uniswap': launchpadDefinitions[LaunchpadId.UNISWAP_AUCTIONS].logo,
  'up': '/images/liquidity-providers/up.webp',
  'velodrome': '/images/liquidity-providers/velodrome.webp',
  'virtuals': launchpadDefinitions[LaunchpadId.VIRTUAL].logo,
  'waultswap': '/images/liquidity-providers/waultswap.webp',
  'wombat': '/images/liquidity-providers/wombat.webp',
  'woofi': '/images/liquidity-providers/woofi.webp',
  'wrapped_mlt': '/images/liquidity-providers/wmlt.webp',
  'xfai': '/images/liquidity-providers/xfai.webp',
  'yearn': '/images/liquidity-providers/yearn.webp',
  'yoshi': '/images/liquidity-providers/yoshi.webp',
  'z_protocol': '/images/liquidity-providers/zprotocol.webp',
  'zebra': '/images/liquidity-providers/zebra.webp',
} as const;

// Historical identifiers that need an explicit alias after normalization and prefix matching.
// For example, MakerPsm does not match the 0x family key "maker_psm".
export const tradeHistoryMappings = {
  apeswapfinance: liquidityProviderLogos.apeswap,
  kyberelastic: liquidityProviderLogos.kyberdmm,
  makerpsm: liquidityProviderLogos.maker_psm,
} as const;

// Jupiter route labels from /swap/v1/program-id-to-label.
// Keep shared providers here too so quote logos do not depend on CoinGecko mappings.
export const jupiterMappings = {
  '1dex': '/images/liquidity-providers/1dex.webp',
  'aldrin': '/images/liquidity-providers/aldrin.webp',
  'bonkswap': '/images/liquidity-providers/bonkswap.webp',
  'crema': '/images/liquidity-providers/crema.webp',
  'cropper': '/images/liquidity-providers/cropper.webp',
  'dexlab': '/images/liquidity-providers/dexlab.webp',
  'fluxbeam': '/images/liquidity-providers/fluxbeam.webp',
  'guacswap': '/images/liquidity-providers/guacswap.webp',
  'helium_network': '/images/liquidity-providers/heliumnetwork.webp',
  'invariant': '/images/liquidity-providers/invariant.webp',
  'mercurial': '/images/liquidity-providers/mercurial.webp',
  'meteora': launchpadDefinitions[LaunchpadId.METEORA_DBC].logo,
  'obric': '/images/liquidity-providers/obric.webp',
  'openbook': '/images/liquidity-providers/openbook.webp',
  'orca': liquidityProviderLogos.orcawhirlpools,
  'penguin': '/images/liquidity-providers/penguin.webp',
  'perena': '/images/liquidity-providers/perena.webp',
  'perps': '/images/liquidity-providers/perps.webp',
  'phoenix': '/images/liquidity-providers/phoenix.webp',
  'pump.fun': liquidityProviderLogos.pumpfun,
  'raydium': liquidityProviderLogos.raydiumamm,
  'raydium_launchlab': launchpadDefinitions[LaunchpadId.LAUNCHLAB].logo,
  'saber': '/images/liquidity-providers/saber.webp',
  'sanctum': '/images/liquidity-providers/sanctum.webp',
  'saros': '/images/liquidity-providers/saros.webp',
  'solayer': '/images/liquidity-providers/solayer.webp',
  'stabble_stable_swap': liquidityProviderLogos.stabblestableswap,
  'stabble_weighted_swap': liquidityProviderLogos.stabbleweightedswap,
  // The 0x Solana quote adapter also uses Jupiter's Whirlpool label.
  'whirlpool': liquidityProviderLogos.orcawhirlpools,
} as const;

// CoinGecko DEX IDs from token pools: aliases, additional providers and specific logo overrides.
// Normalize keys to lowercase with underscores, e.g. "raydium-launchlab" → "raydium_launchlab".
export const coinGeckoMappings = {
  alien_base: liquidityProviderLogos.alienbase,
  argus: launchpadDefinitions[LaunchpadId.ARGUS].logo,
  bankr: launchpadDefinitions[LaunchpadId.BANKR].logo,
  beethoven_x: liquidityProviderLogos.beethovenx,
  clanker: launchpadDefinitions[LaunchpadId.CLANKER].logo,
  daos_fun: '/images/liquidity-providers/daosfun.webp',
  dexlab: '/images/liquidity-providers/dexlab.webp',
  fluxbeam: '/images/liquidity-providers/fluxbeam.webp',
  four_meme: liquidityProviderLogos.fourmeme,
  kyberswap: liquidityProviderLogos.kyberdmm,
  merchant_moe: liquidityProviderLogos.merchantmoe,
  meteora: launchpadDefinitions[LaunchpadId.METEORA_DBC].logo,
  moonshot: launchpadDefinitions[LaunchpadId.MOONSHOT].logo,
  nuri: liquidityProviderLogos.nuri_cl,
  o1_launchpad: launchpadDefinitions[LaunchpadId.O1_EXCHANGE].logo,
  orca: liquidityProviderLogos.orcawhirlpools,
  pump_fun: liquidityProviderLogos.pumpfun,
  raydium: liquidityProviderLogos.raydiumamm,
  raydium_launchlab: launchpadDefinitions[LaunchpadId.LAUNCHLAB].logo,
  saros: '/images/liquidity-providers/saros.webp',
  token_mill: '/images/liquidity-providers/tokenmill.webp',
  uniswap_pools_trade: launchpadDefinitions[LaunchpadId.POOLS_TRADE].logo,
  zora: launchpadDefinitions[LaunchpadId.ZORA].logo,
} as const;

const logosByName = new Map<string, string>(
  Object.entries({
    ...coinGeckoMappings,
    ...tradeHistoryMappings,
    ...jupiterMappings,
    ...liquidityProviderLogos,
  }),
);

// Prefer specific prefixes such as "uniswap_pools_trade" over "uniswap".
const logoPrefixes = [...logosByName.entries()].sort(([a], [b]) => b.length - a.length);

const normalizeName = (name: string) =>
  name.trim().replaceAll(' ', '_').replaceAll('-', '_').toLowerCase();

export const getLiquidityProviderLogoSrc = (name: string): string | undefined => {
  // Keep the fallback for trade-history fields containing multiple comma-separated providers.
  if (name.includes(',')) return undefined;

  const normalizedName = normalizeName(name);

  // Try exact names, then "provider_" prefixes, then "providerv" prefixes.
  return (
    logosByName.get(normalizedName) ??
    logoPrefixes.find(([provider]) => normalizedName.startsWith(`${provider}_`))?.[1] ??
    logoPrefixes.find(([provider]) => normalizedName.startsWith(`${provider}v`))?.[1]
  );
};
